/**
 * Dominio do avatar do usuario: o MESMO par de `ChannelAvatar` — slug lucide
 * kebab + hex `#rrggbb`. Sem valor NAO e erro: e o fallback pras iniciais.
 */

export const PROFILE_AVATAR_ICON_KEY = 'profile:avatar-icon'
export const PROFILE_AVATAR_COLOR_KEY = 'profile:avatar-color'

/** Ordem estavel: e o que "Restaurar padrao" da secao Perfil apaga. */
export const PROFILE_AVATAR_KEYS = [
  PROFILE_AVATAR_ICON_KEY,
  PROFILE_AVATAR_COLOR_KEY,
] as const

/**
 * Copia deliberada de `(private)/admin/channels/_lib/channelPatch.ts` — as duas
 * regexes sao VERBATIM do back. Aquele arquivo e `_lib` privado da rota de
 * admin; importar de `/conta` atravessaria fronteira de rota. 2a ocorrencia:
 * duplicar. Na 3a, promover pra `src/lib/appearance/`.
 */
const ICON_SLUG_RE = /^[a-z0-9][a-z0-9-]{0,31}$/
const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/

/** Slug KEBAB (o que se persiste). PascalCase e assunto do `IconPicker`, na borda. */
export function toProfileAvatarIcon(value: string | null | undefined): string | null {
  if (!value) return null
  return ICON_SLUG_RE.test(value) ? value : null
}

export function toProfileAvatarColor(value: string | null | undefined): string | null {
  if (!value) return null
  return HEX_COLOR_RE.test(value) ? value.toLowerCase() : null
}
